import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  RemoteAttachment3uyi4s0lht7h0 as RemoteAttachment,
  FileDataw8niis0ucpno as FileData,
} from '../views/components/files/attachmentFilePreview.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toFileData(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(_this__u8e3s4, 10));
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = new (FileData())(VOID, Signal().fak(item.u79_1), new (RemoteAttachment())(item), new (RemoteAttachment())(item));
    destination.v(tmp$ret$0);
  }
  return destination;
}
//region block: exports
export {
  toFileData as toFileData1whrjalotozwt,
};
//endregion

//# sourceMappingURL=ProjectAttachment.ext.mjs.map
